import { render, staticRenderFns } from "./sound.vue?vue&type=template&id=49f78f7d&scoped=true&"
import script from "./sound.vue?vue&type=script&lang=js&"
export * from "./sound.vue?vue&type=script&lang=js&"
import style0 from "./sound.vue?vue&type=style&index=0&id=49f78f7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f78f7d",
  null
  
)

export default component.exports